<template>
  <footer class="bg-dark py-5 text-secondary">
    <div class="container">
      <div class="row mb-4 border-bottom border-dark pb-5">
        <div class="col-md col-xl-2 d-none d-md-block">
          <dl class="flex-grow-1 text-secondary">
            <dt class="text-white font-weight-normal mb-3">证书课</dt>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/cfa1`" class="text-reset"
                >CFA Level I</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/cfa2`" class="text-reset"
                >CFA Level II</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/cfa3`" class="text-reset"
                >CFA Level III</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/frm1`" class="text-reset"
                >FRM I</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/frm2`" class="text-reset"
                >FRM II</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/cate/3`" class="text-reset"
                >CPA注册会计师</a
              >
              <!-- <router-link to="/mall/cpa" class="text-reset">CPA注册会计师</router-link> -->
            </dd>
          </dl>
        </div>
        <div class="col-md-4 col-xl-3 d-none d-md-block">
          <dl class="flex-grow-1 text-secondary">
            <dt class="text-white font-weight-normal mb-3">金融实务</dt>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/other/229`" class="text-reset"
                >Python初阶小课-基础语法篇</a
              >
            </dd>
            <dd class="mb-3">
              <a
                :href="`${RedirectUrl.MALL_PAGE}/other/6171`"
                class="text-reset"
                >Python量化：量化全线(合集)</a
              >
            </dd>
            <dd class="mb-3">
              <a
                :href="`${RedirectUrl.MALL_PAGE}/other/5823`"
                class="text-reset"
                >Python与数据分析</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/other/214`" class="text-reset"
                >可视化和时间序列-基础篇</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/other/215`" class="text-reset"
                >Fintech初探</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/other/219`" class="text-reset"
                >Excel和VBA金融建模-合集</a
              >
            </dd>
            <dd class="mb-3">
              <a :href="`${RedirectUrl.MALL_PAGE}/other/220`" class="text-reset"
                >Excel公司估值建模</a
              >
            </dd>
          </dl>
        </div>
        <div class="col-md col-xl-2">
          <dl class="flex-grow-1 text-secondary">
            <dt class="text-white font-weight-normal mb-3">品职教育</dt>
            <div class="d-flex flex-md-column justify-content-between">
              <dd class="mb-3">
                <a
                  :href="RedirectUrl.ABOUT_PAGE"
                  target="_blank"
                  class="text-reset"
                  >关于我们</a
                >
              </dd>
              <dd class="mb-3">
                <a :href="RedirectUrl.TEACHERS_PAGE" class="text-reset"
                  >顶尖师资</a
                >
              </dd>
              <dd class="mb-3">
                <a
                  :href="RedirectUrl.ARTICLES_PAGE"
                  target="_blank"
                  class="text-reset"
                  >原创文章</a
                >
              </dd>
            </div>
            <div class="d-flex flex-md-column justify-content-between">
              <dd class="mb-3">
                <a :href="RedirectUrl.READER_PAGE" class="text-reset"
                  >读者中心</a
                >
              </dd>
              <dd class="mb-3">
                <a
                  href="https://resources.pzacademy.com/legal.html"
                  target="_blank"
                  class="text-reset"
                  >学员协议</a
                >
              </dd>
              <dd class="mb-3">
                <a
                  href="https://resources.pzacademy.com/privacy.html"
                  class="text-reset"
                  >隐私政策</a
                >
              </dd>
              <dd class="mb-3">
                <a
                  class="d-none d-md-inline-block bg-grey-300"
                  rel="nofollow"
                  href="https://www.garp.org/#!/frm/exam-preparation-providers/pzacademy-co-ltd"
                  target="_blank"
                >
                  <img
                    src="https://resources.pzacademy.com/image/logo/garp_logo.png"
                    height="42"
                    alt="FRM | GARP"
                  />
                </a>
              </dd>
            </div>
          </dl>
        </div>
        <div class="col-md-4 col-xl-4 d-flex flex-lg-column">
          <dl class="flex-grow-1 text-secondary">
            <dt class="text-white font-weight-normal mb-3">联系方式</dt>
            <dd class="mb-3">
              <i class="pz-icon icon-call mr-2 text-white-50 _sm mt-1"></i>
              +86 400-9934-900
            </dd>
            <dd class="mb-3">
              <i class="pz-icon icon-email mr-2 text-white-50 _sm mt-1"></i>
              <a href="mailto:support@pzacademy.com" class="text-reset"
                >support@pzacademy.com</a
              >
            </dd>
            <dd class="mb-3">
              <i class="pz-icon icon-weixin mr-2 text-white-50 _sm mt-1"></i>
              <div class="btn-group dropup">
                <a
                  href="#"
                  class="text-reset"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-offset="-90,10"
                  >售前客服微信号</a
                >
                <div class="dropdown-menu text-center p-0">
                  <div class="d-flex">
                    <div>
                      <p class="small mb-1 mt-2 position-relative">
                        证书课程扫码
                        <br />请回复：你好
                      </p>
                      <img
                        src="https://resources.pzacademy.com/image/qrcode/qrcode-sales.png"
                        width="150"
                        height="150"
                      />
                    </div>
                    <div>
                      <p class="small mb-1 mt-2 position-relative">
                        金融实务扫码
                        <br />请回复：小课
                      </p>
                      <img
                        src="https://resources.pzacademy.com/image/qrcode/qrcode-sales2.png"
                        width="150"
                        height="150"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </dd>
            <dd class="mb-3">
              <i class="pz-icon icon-weixin mr-2 text-white-50 _sm mt-1"></i>
              <div class="btn-group dropup">
                <a
                  href="#"
                  class="text-reset"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-offset="-40,10"
                  >技术客服微信号</a
                >
                <div class="dropdown-menu text-center p-0">
                  <p class="small mb-1 mt-2 position-relative">
                    扫描二维码
                    <br />请回复：你好！
                  </p>
                  <img
                    src="https://resources.pzacademy.com/image/qrcode/qrcode-tech.png"
                    width="150"
                    height="150"
                  />
                </div>
              </div>
            </dd>
            <dd>
              <div class="media">
                <i
                  class="pz-icon icon-location mr-2 text-white-50 _sm mt-1"
                ></i>
                <a
                  class="media-body text-reset"
                  target="_blank"
                  href="https://map.baidu.com/poi/%E6%B0%B8%E8%BE%BE%E5%9B%BD%E9%99%85%E5%A4%A7%E5%8E%A6/@13533234.38,3637957.822876838,17.77z?uid=07f3c8b52bdb4f626340a9ac&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
                  >上海浦东新区龙阳路2277号永达国际大厦西裙房，105室</a
                >
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <div
        class="
          row
          border-bottom border-dark
          pb-4
          mb-4
          text-center
          d-none d-md-flex
        "
      >
        <h5 class="col-12 text-center mb-4">
          <img
            src="https://resources.pzacademy.com/image/www-ui/4e148543547645d195048628ada1e054.png"
          />
        </h5>
        <div class="col small">
          <div class="btn-group dropup">
            <a
              href="#"
              class="text-secondary text-decoration-none"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-offset="-40,10"
            >
              <p class="mb-2">
                <img
                  src="https://resources.pzacademy.com/image/logo/wx-cfa.jpg"
                  width="30"
                  height="30"
                  class="rounded-lg"
                />
              </p>
              CFA学习课程
            </a>
            <div class="dropdown-menu text-center p-0">
              <p class="small mb-1 mt-2 text-secondary position-relative">
                扫描二维码
                <br />关注CFA课程学习公众号
              </p>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-cfa.png"
                width="150"
                height="150"
              />
            </div>
          </div>
        </div>
        <div class="col small">
          <div class="btn-group dropup">
            <a
              href="#"
              class="text-secondary text-decoration-none"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-offset="-40,10"
            >
              <p class="mb-2">
                <img
                  src="https://resources.pzacademy.com/image/logo/wx-frm.jpg"
                  width="30"
                  height="30"
                  class="rounded-lg"
                />
              </p>
              FRM充电站
            </a>
            <div class="dropdown-menu text-center p-0">
              <p class="small mb-1 mt-2 text-secondary position-relative">
                扫描二维码
                <br />关注FRM充电站公众号
              </p>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-frm.png"
                width="150"
                height="150"
              />
            </div>
          </div>
        </div>
        <div class="col small">
          <div class="btn-group dropup">
            <a
              href="#"
              class="text-secondary text-decoration-none"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-offset="-40,10"
            >
              <p class="mb-2">
                <img
                  src="https://resources.pzacademy.com/image/logo/wx-cpa.jpg"
                  width="30"
                  height="30"
                  class="rounded-lg"
                />
              </p>
              CPA充电站
            </a>
            <div class="dropdown-menu text-center p-0">
              <p class="small mb-1 mt-2 text-secondary position-relative">
                扫描二维码
                <br />关注CPA充电站公众号
              </p>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-cpa.png"
                width="150"
                height="150"
              />
            </div>
          </div>
        </div>

        <div class="col small">
          <div class="btn-group dropup">
            <a
              href="#"
              class="text-secondary text-decoration-none"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-offset="-40,10"
            >
              <p class="mb-2">
                <img
                  src="https://resources.pzacademy.com/image/logo/wx-read.jpg"
                  width="30"
                  height="30"
                  class="rounded-lg"
                />
              </p>
              品职伴读
            </a>
            <div class="dropdown-menu text-center p-0">
              <p class="small mb-1 mt-2 text-secondary position-relative">
                扫描二维码
                <br />关注品职伴读公众号
              </p>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-read.png"
                width="150"
                height="150"
              />
            </div>
          </div>
        </div>
        <div class="col small">
          <div class="btn-group dropup">
            <a
              href="#"
              class="text-secondary text-decoration-none"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-offset="-40,10"
            >
              <p class="mb-2">
                <img
                  src="https://resources.pzacademy.com/image/logo/wx-xueyuan.jpg"
                  width="30"
                  height="30"
                  class="rounded-lg"
                />
              </p>
              品职课堂
            </a>
            <div class="dropdown-menu text-center p-0">
              <p class="small mb-1 mt-2 text-secondary position-relative">
                扫描二维码
                <br />关注品职课堂公众号
              </p>
              <img
                src="https://resources.pzacademy.com/image/qrcode/qrcode-xueyuan.png"
                width="150"
                height="150"
              />
            </div>
          </div>
        </div>
        <div class="col small">
          <a
            href="https://weibo.com/pzacademy"
            target="_blank"
            class="text-secondary text-decoration-none"
          >
            <p class="mb-2">
              <img
                src="https://resources.pzacademy.com/image/logo/weibo.jpg"
                width="30"
                height="30"
                class="rounded-lg"
              />
            </p>
            官方微博
          </a>
        </div>
        <div class="col small">
          <a
            href="https://www.zhihu.com/org/pin-zhi-jiao-yu"
            target="_blank"
            class="text-secondary text-decoration-none"
          >
            <p class="mb-2">
              <img
                src="https://resources.pzacademy.com/image/logo/zhihu.jpg"
                width="30"
                height="30"
                class="rounded-lg"
              />
            </p>
            官方知乎
          </a>
        </div>
      </div>
      <div
        class="
          d-flex
          flex-column flex-column-reverse flex-md-row
          justify-content-between
          align-items-center
          mb-3
          small
          text-secondary
        "
      >
        <div class="d-flex flex-column flex-md-row align-items-center">
          <div v-if="!isInIframe">
            <img
              src="https://resources.pzacademy.com/image/www-ui/beian.png"
              class="mr-1"
              height="16"
            />
            <a
              class="text-reset mr-3"
              href="https://beian.mps.gov.cn/#/query/webSearch?code=31011802004852\" rel="noreferrer" target="_blank"
              >沪公网安备 31011802004852号</a
            >
          </div>
          <div>
            <img
              src="https://resources.pzacademy.com/image/www-ui/icp.gif"
              class="mr-1"
              height="18"
            />
            <a
              class="text-reset"
              href="http://www.beian.miit.gov.cn"
              target="_blank"
              >沪ICP备 {{ isInIframe ? '20012216号' : '15048842号-1' }}</a
            >
          </div>
        </div>

        <div class>
          © 2015-{{ new Date().getFullYear() }} PZ Academy. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  props: {
    RedirectUrl: Object,
  },
  data: () => {
    return {
      isInIframe: false,
    };
  },
  mounted() {
    if (window.frames.length != parent.frames.length) {
      this.isInIframe = true;
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
